import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Nullable } from "../../../Types/Common";

type ModuleKey = keyof FinancialYearState;
export interface FinancialYearState {
  attendance: {
    selectedFinancialYear: Nullable<string>;
  };
  leave: {
    selectedFinancialYear: Nullable<string>;
  };
  conveyance: {
    selectedFinancialYear: Nullable<string>;
  };
  pettyCashAccountZone: {
    selectedFinancialYear: Nullable<string>;
  };
  reimbursement: {
    selectedFinancialYear: Nullable<string>;
  };
  teamMemberAttendance: {
    selectedFinancialYear: Nullable<string>;
  };
  teamMemberLeave: {
    selectedFinancialYear: Nullable<string>;
  };
}

const initialState: FinancialYearState = {
  attendance: {
    selectedFinancialYear: null,
  },
  leave: {
    selectedFinancialYear: null,
  },
  conveyance: {
    selectedFinancialYear: null,
  },
  pettyCashAccountZone: {
    selectedFinancialYear: null,
  },
  reimbursement: {
    selectedFinancialYear: null,
  },
  teamMemberAttendance: {
    selectedFinancialYear: null,
  },
  teamMemberLeave: {
    selectedFinancialYear: null,
  },
};

const financialYearSlice = createSlice({
  name: "financialYearModules",
  initialState,
  reducers: {
    setSelectedFinancialYear: (
      state,
      action: PayloadAction<{ module: ModuleKey; year: string }>
    ) => {
      const { module, year } = action.payload;
      if (state[module].selectedFinancialYear !== year) {
        state[module].selectedFinancialYear = year;
      }
    },
    resetSelectedFinancialYear: (
      state,
      action: PayloadAction<{ module: ModuleKey }>
    ) => {
      const { module } = action.payload;
      state[module].selectedFinancialYear = null;
    },
  },
});

export const { setSelectedFinancialYear, resetSelectedFinancialYear } =
  financialYearSlice.actions;
export default financialYearSlice.reducer;
